/**
 * @generated SignedSource<<4344585b4411f0bfb404a032fddafc4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarAuctionItemsLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItems_viewer">;
  readonly " $fragmentType": "PdpRespSimilarAuctionItemsLazy_viewer";
};
export type PdpRespSimilarAuctionItemsLazy_viewer$key = {
  readonly " $data"?: PdpRespSimilarAuctionItemsLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItemsLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarAuctionItemsLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ce2f3ddad47573a73e92899cf94d10ce";

export default node;
